import { TranslatedString } from 'lemunzo-api';
import {
    AddedElementModel,
    AddedElementVisibility,
    ElementType,
} from './added-element-model';
import { OptionModel } from './option-model';

/**
 * Represents a model for an element with options (e.g. checkbox, radio or select), extending the base AddedElementModel.
 */
export class ElementWithOptionsModel extends AddedElementModel {
    options: OptionModel[];

    constructor(
        inputType: ElementType,
        name: TranslatedString,
        label: TranslatedString,
        options: OptionModel[],
        required: boolean = false,
        visible: AddedElementVisibility = AddedElementVisibility.AlwaysEditable,
        deletable: boolean = true,
        defaultElement: boolean = false
    ) {
        super(
            inputType,
            name,
            label,
            required,
            visible,
            deletable,
            defaultElement
        );
        this.options = options;
    }
}
